var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path27, _path28, _path29, _path30, _ellipse5, _ellipse6, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _circle, _circle2, _circle3, _circle4, _path40, _path41, _path42, _circle5, _circle6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMydashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "undraw_joyride_re_968t",
    xmlns: "http://www.w3.org/2000/svg",
    width: 212.386,
    height: 169.513,
    viewBox: "0 0 212.386 169.513",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_18947",
    "data-name": "Path 18947",
    d: "M86.348,0C134.036,0,172.7,33.282,172.7,74.339H0C0,33.282,38.659,0,86.348,0Z",
    transform: "translate(39.691 94.364)",
    fill: "#ffcd50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17604",
    "data-name": "Path 17604",
    d: "M884.391,725.786l-3.372,3.1,2.68-4.5a34.726,34.726,0,0,0-5.564-7.138s-7.164,6.863-7.164,12.259,3.207,7.279,7.164,7.279,7.164-1.884,7.164-7.279A9.466,9.466,0,0,0,884.391,725.786Z",
    transform: "translate(-704.622 -567.31)",
    fill: "#3a8365"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17605",
    "data-name": "Path 17605",
    d: "M902.232,728.131v.266a14.2,14.2,0,0,1-1.56,7.2c-.014.025-.03.049-.045.074l-.115-.07-.109-.068a14.044,14.044,0,0,0,1.551-7.122c0-.087,0-.175,0-.263,0-1.141-.074-2.3-.185-3.418-.008-.087-.017-.175-.026-.263-.156-1.48-.379-2.894-.608-4.122-.016-.087-.033-.174-.05-.26-.4-2.077-.8-3.582-.893-3.915-.01-.041-.017-.063-.018-.068l.125-.036h0l.126-.036c0,.005.024.081.06.22.141.521.507,1.937.867,3.8.016.084.033.171.049.258.187,1,.37,2.11.515,3.279q.055.44.1.869c.01.088.02.176.027.263Q902.225,726.541,902.232,728.131Z",
    transform: "translate(-726.702 -566.382)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17606",
    "data-name": "Path 17606",
    d: "M891.891,730.606c-.088.012-.178.024-.268.033a7.208,7.208,0,0,1-.743.038,7.065,7.065,0,0,1-3.054-.69l-.167.211a7.329,7.329,0,0,0,3.221.743,7.552,7.552,0,0,0,.792-.042c.09-.009.179-.021.267-.034a7.268,7.268,0,0,0,2.1-.636l-.166-.213A7.047,7.047,0,0,1,891.891,730.606Z",
    transform: "translate(-717.239 -576.935)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17607",
    "data-name": "Path 17607",
    d: "M888.064,741.178q-.136.008-.273.008h-.084a7.1,7.1,0,0,1-5.83-3.045c-.053.078-.105.155-.157.234a7.366,7.366,0,0,0,5.986,3.074h.111c.092,0,.183,0,.274-.008a7.327,7.327,0,0,0,3.9-1.369c-.042-.078-.084-.155-.128-.233a7.053,7.053,0,0,1-3.8,1.339Z",
    transform: "translate(-712.75 -583.101)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17608",
    "data-name": "Path 17608",
    d: "M885.13,749.832c-.092.008-.184.013-.276.017s-.2.007-.3.007a7.122,7.122,0,0,1-6.828-5.124c-.059.107-.118.212-.175.319a7.383,7.383,0,0,0,7,5.069c.1,0,.2,0,.295-.007s.186-.008.278-.015a7.36,7.36,0,0,0,4.858-2.371c-.028-.1-.059-.194-.091-.291A7.1,7.1,0,0,1,885.13,749.832Z",
    transform: "translate(-709.6 -588.084)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17609",
    "data-name": "Path 17609",
    d: "M799.95,247.435l.142-2.692.722,2.992a20.424,20.424,0,0,0,5.274.713s.19-5.831-2.028-8.1-4.341-1.742-6-.115-2.237,3.737-.019,6.006a5.565,5.565,0,0,0,1.915,1.195Z",
    transform: "translate(-648.378 -205.581)",
    fill: "#3a8365"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17610",
    "data-name": "Path 17610",
    d: "M804.664,249.351l-.109-.112a8.351,8.351,0,0,1-2.3-3.669c0-.016-.007-.033-.011-.049l.077-.018.074-.016a8.261,8.261,0,0,0,2.276,3.632c.035.037.071.075.108.111.471.478.975.935,1.483,1.361l.119.1c.674.558,1.349,1.061,1.951,1.483l.128.088c1.021.711,1.81,1.177,1.985,1.279l.036.021-.038.066h0l-.039.067s-.043-.024-.116-.068c-.273-.161-1.009-.606-1.928-1.243l-.126-.088c-.488-.342-1.023-.735-1.565-1.167q-.2-.162-.4-.325l-.12-.1Q805.321,250.017,804.664,249.351Z",
    transform: "translate(-652.656 -210.616)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17611",
    "data-name": "Path 17611",
    d: "M824.994,268.911c.032-.041.065-.083.1-.124a4.31,4.31,0,0,1,.3-.321,4.155,4.155,0,0,1,1.568-.966c-.005-.052-.011-.1-.016-.157a4.309,4.309,0,0,0-1.66,1.012,4.391,4.391,0,0,0-.316.343c-.034.041-.067.083-.1.124a4.271,4.271,0,0,0-.621,1.131l.158.021A4.143,4.143,0,0,1,824.994,268.911Z",
    transform: "translate(-669.295 -227.14)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17612",
    "data-name": "Path 17612",
    d: "M815.03,262.658q.054-.059.111-.115l.035-.035a4.177,4.177,0,0,1,3.7-1.116c-.01-.054-.02-.109-.03-.163a4.332,4.332,0,0,0-3.781,1.169l-.046.046c-.038.038-.075.077-.112.116a4.308,4.308,0,0,0-1.078,2.181l.149.046A4.146,4.146,0,0,1,815.03,262.658Z",
    transform: "translate(-661.421 -222.467)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17613",
    "data-name": "Path 17613",
    d: "M808.527,256.4c.036-.041.072-.081.109-.121s.08-.084.122-.125a4.188,4.188,0,0,1,4.977-.653c-.019-.069-.037-.138-.057-.206a4.342,4.342,0,0,0-5.028.748c-.041.041-.082.082-.121.124s-.075.08-.111.12a4.328,4.328,0,0,0-1.068,2.994c.052.03.1.057.158.085A4.175,4.175,0,0,1,808.527,256.4Z",
    transform: "translate(-656.519 -217.664)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17614",
    "data-name": "Path 17614",
    d: "M380.711,329.435l.141-2.692.722,2.992a20.42,20.42,0,0,0,5.274.713s.19-5.831-2.028-8.1-4.341-1.742-6-.115-2.237,3.737-.019,6.006a5.564,5.564,0,0,0,1.915,1.195Z",
    transform: "translate(-331.401 -267.579)",
    fill: "#3a8365"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17615",
    "data-name": "Path 17615",
    d: "M385.425,331.351l-.109-.112a8.35,8.35,0,0,1-2.3-3.669c0-.016-.007-.033-.012-.049l.077-.018.074-.016a8.259,8.259,0,0,0,2.276,3.632c.035.037.071.075.108.111.471.478.975.935,1.483,1.361l.119.1c.674.558,1.349,1.061,1.95,1.483l.128.089c1.021.711,1.809,1.177,1.985,1.279l.036.021-.038.066h0l-.039.067-.116-.068c-.274-.161-1.009-.606-1.928-1.243l-.126-.089c-.488-.342-1.023-.735-1.565-1.167q-.2-.162-.4-.325c-.041-.033-.081-.066-.12-.1Q386.082,332.017,385.425,331.351Z",
    transform: "translate(-335.679 -272.614)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17616",
    "data-name": "Path 17616",
    d: "M405.755,350.911c.032-.041.065-.083.1-.124a4.233,4.233,0,0,1,.3-.321,4.154,4.154,0,0,1,1.568-.966l-.016-.157a4.308,4.308,0,0,0-1.66,1.012,4.439,4.439,0,0,0-.316.344c-.034.041-.067.083-.1.124a4.273,4.273,0,0,0-.621,1.131l.157.021A4.141,4.141,0,0,1,405.755,350.911Z",
    transform: "translate(-352.318 -289.139)",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17617",
    "data-name": "Path 17617",
    d: "M395.791,344.658q.054-.059.111-.115l.035-.035a4.176,4.176,0,0,1,3.7-1.116c-.01-.054-.02-.109-.031-.163a4.332,4.332,0,0,0-3.781,1.169l-.046.046c-.038.038-.075.077-.112.116a4.309,4.309,0,0,0-1.078,2.181l.15.045A4.148,4.148,0,0,1,395.791,344.658Z",
    transform: "translate(-344.444 -284.466)",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17618",
    "data-name": "Path 17618",
    d: "M389.288,338.4c.035-.041.072-.081.109-.121s.08-.084.122-.125a4.188,4.188,0,0,1,4.977-.653c-.019-.069-.037-.138-.057-.206a4.341,4.341,0,0,0-5.028.748c-.041.041-.082.082-.121.124s-.075.08-.111.12a4.329,4.329,0,0,0-1.068,2.994c.052.03.1.057.158.085A4.174,4.174,0,0,1,389.288,338.4Z",
    transform: "translate(-339.542 -279.663)",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17619",
    "data-name": "Path 17619",
    d: "M450.711,189.435l.141-2.691.722,2.992a20.423,20.423,0,0,0,5.274.713s.19-5.831-2.028-8.1-4.341-1.742-6-.115-2.237,3.737-.019,6.006A5.565,5.565,0,0,0,450.711,189.435Z",
    transform: "translate(-384.326 -161.728)",
    fill: "#3a8365"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17620",
    "data-name": "Path 17620",
    d: "M455.425,191.351l-.109-.112a8.35,8.35,0,0,1-2.3-3.669c0-.016-.007-.033-.012-.049l.077-.018.074-.016a8.261,8.261,0,0,0,2.276,3.632c.035.037.071.075.108.111.471.478.975.935,1.483,1.361l.119.1c.674.558,1.349,1.061,1.95,1.483l.128.088c1.021.71,1.809,1.177,1.985,1.279l.036.021-.038.066h0l-.039.067-.116-.068c-.274-.161-1.009-.606-1.928-1.243l-.126-.088c-.488-.342-1.023-.735-1.565-1.167q-.2-.162-.4-.325l-.12-.1Q456.082,192.017,455.425,191.351Z",
    transform: "translate(-388.604 -166.764)",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17621",
    "data-name": "Path 17621",
    d: "M475.755,210.911c.032-.041.065-.083.1-.124a4.259,4.259,0,0,1,.3-.321,4.155,4.155,0,0,1,1.568-.966l-.016-.157a4.309,4.309,0,0,0-1.66,1.012,4.444,4.444,0,0,0-.316.344c-.034.041-.067.082-.1.124a4.268,4.268,0,0,0-.621,1.131l.157.021A4.141,4.141,0,0,1,475.755,210.911Z",
    transform: "translate(-405.243 -183.288)",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17622",
    "data-name": "Path 17622",
    d: "M465.791,204.658q.054-.059.111-.115l.035-.035a4.177,4.177,0,0,1,3.7-1.116c-.01-.054-.02-.109-.03-.163a4.332,4.332,0,0,0-3.781,1.169l-.046.046c-.038.038-.075.077-.112.116a4.309,4.309,0,0,0-1.078,2.181l.149.045A4.148,4.148,0,0,1,465.791,204.658Z",
    transform: "translate(-397.37 -178.615)",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17623",
    "data-name": "Path 17623",
    d: "M459.288,198.4c.036-.041.072-.081.109-.121s.08-.084.122-.125a4.188,4.188,0,0,1,4.977-.653c-.019-.069-.037-.138-.057-.206a4.341,4.341,0,0,0-5.028.748c-.041.041-.082.082-.121.124s-.075.08-.111.12a4.329,4.329,0,0,0-1.068,2.994c.052.03.1.057.158.085A4.174,4.174,0,0,1,459.288,198.4Z",
    transform: "translate(-392.467 -173.812)",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17624",
    "data-name": "Path 17624",
    d: "M229.611,672.374l-5.842,5.378,4.642-7.79a60.162,60.162,0,0,0-9.639-12.365s-12.41,11.89-12.41,21.236,5.556,12.61,12.41,12.61,12.41-3.263,12.41-12.61A16.394,16.394,0,0,0,229.611,672.374Z",
    transform: "translate(-202.127 -522.203)",
    fill: "#3a8365"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17625",
    "data-name": "Path 17625",
    d: "M260.518,676.436v.461c-.027,5.355-.93,9.533-2.7,12.475-.025.044-.052.084-.078.128l-.2-.121-.189-.118c1.966-3.177,2.662-7.668,2.687-12.339,0-.15,0-.3,0-.456-.007-1.977-.128-3.977-.322-5.921-.014-.15-.03-.3-.046-.456-.269-2.563-.657-5.013-1.054-7.141-.027-.151-.057-.3-.087-.449-.687-3.6-1.387-6.206-1.546-6.783-.018-.071-.03-.109-.032-.119l.217-.062,0,0,.219-.062c0,.009.041.139.1.381.244.9.878,3.355,1.5,6.589.027.146.057.3.084.447.324,1.727.641,3.656.892,5.681q.1.763.171,1.505c.018.153.034.306.048.456Q260.506,673.683,260.518,676.436Z",
    transform: "translate(-240.378 -520.596)",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17626",
    "data-name": "Path 17626",
    d: "M242.6,680.724c-.153.021-.308.041-.465.057a12.628,12.628,0,0,1-1.286.066,12.24,12.24,0,0,1-5.291-1.2l-.29.365a12.69,12.69,0,0,0,5.581,1.286,12.976,12.976,0,0,0,1.373-.073c.155-.016.31-.036.463-.059a12.588,12.588,0,0,0,3.638-1.1l-.287-.37A12.2,12.2,0,0,1,242.6,680.724Z",
    transform: "translate(-223.984 -538.878)",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17627",
    "data-name": "Path 17627",
    d: "M235.973,699.038q-.236.014-.472.014c-.048,0-.1,0-.146,0a12.3,12.3,0,0,1-10.1-5.275c-.091.135-.182.269-.271.406a12.76,12.76,0,0,0,10.37,5.325c.064,0,.128,0,.192,0,.16,0,.317-.007.474-.014a12.693,12.693,0,0,0,6.762-2.372c-.073-.135-.146-.269-.221-.4A12.218,12.218,0,0,1,235.973,699.038Z",
    transform: "translate(-216.208 -549.559)",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17628",
    "data-name": "Path 17628",
    d: "M230.891,714.031c-.16.014-.319.023-.479.03s-.342.011-.513.011a12.337,12.337,0,0,1-11.828-8.876c-.1.185-.205.367-.3.552a12.788,12.788,0,0,0,12.131,8.781c.171,0,.342,0,.511-.011s.322-.014.481-.025a12.752,12.752,0,0,0,8.416-4.108c-.048-.169-.1-.335-.157-.5A12.3,12.3,0,0,1,230.891,714.031Z",
    transform: "translate(-210.751 -558.191)",
    fill: "#fff"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_939",
    "data-name": "Ellipse 939",
    cx: 20.368,
    cy: 10.611,
    rx: 20.368,
    ry: 10.611,
    transform: "matrix(0.753, -0.659, 0.659, 0.753, 148.214, 101.886)",
    fill: "#fff"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_940",
    "data-name": "Ellipse 940",
    cx: 10.611,
    cy: 20.368,
    rx: 10.611,
    ry: 20.368,
    transform: "matrix(0.659, -0.753, 0.753, 0.659, 14.788, 91.031)",
    fill: "#fff"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_941",
    "data-name": "Ellipse 941",
    cx: 20.368,
    cy: 10.611,
    rx: 20.368,
    ry: 10.611,
    transform: "translate(51.129 147.804)",
    fill: "#fff"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_942",
    "data-name": "Ellipse 942",
    cx: 20.368,
    cy: 10.611,
    rx: 20.368,
    ry: 10.611,
    transform: "translate(115.768 147.804)",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17629",
    "data-name": "Path 17629",
    d: "M459.614,425.481a50,50,0,1,1,50-50A50.061,50.061,0,0,1,459.614,425.481Zm0-99.521a49.516,49.516,0,1,0,49.516,49.516A49.573,49.573,0,0,0,459.614,325.96Z",
    transform: "translate(-355.798 -271.091)",
    fill: "#3f3d56"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17630",
    "data-name": "Path 17630",
    d: "M460.927,511.017A44.018,44.018,0,0,1,432.1,460.69a44.01,44.01,0,1,0,82.514,28.385A44.018,44.018,0,0,1,460.927,511.017Z",
    transform: "translate(-369.3 -373.326)",
    fill: "#fff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17631",
    "data-name": "Path 17631",
    d: "M540,477.1c-2.531,0-4.591-2.68-4.591-5.974s2.059-5.974,4.591-5.974,4.591,2.68,4.591,5.974S542.534,477.1,540,477.1Z",
    transform: "translate(-450.914 -376.702)",
    fill: "#3f3d56"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17632",
    "data-name": "Path 17632",
    d: "M654,477.1c-2.531,0-4.591-2.68-4.591-5.974s2.059-5.974,4.591-5.974,4.591,2.68,4.591,5.974S656.534,477.1,654,477.1Z",
    transform: "translate(-537.107 -376.702)",
    fill: "#3f3d56"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_943",
    "data-name": "Ellipse 943",
    cx: 4.391,
    cy: 3.171,
    rx: 4.391,
    ry: 3.171,
    transform: "translate(96.255 2.426)",
    fill: "#2f2e41"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_944",
    "data-name": "Ellipse 944",
    cx: 2.683,
    cy: 1.938,
    rx: 2.683,
    ry: 1.938,
    transform: "translate(97.962 0)",
    fill: "#2f2e41"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17633",
    "data-name": "Path 17633",
    d: "M581.072,115.612c-1.51-1.51-1.988-3.547-1.235-4.857a2.333,2.333,0,0,0-.49.372c-1.238,1.238-.852,3.632.862,5.347s4.108,2.1,5.347.862a2.338,2.338,0,0,0,.373-.49C584.618,117.6,582.582,117.122,581.072,115.612Z",
    transform: "translate(-483.584 -108.748)",
    fill: "#2f2e41"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17634",
    "data-name": "Path 17634",
    d: "M222.544,319.753,221,317.191l9.149-7.168,2.276,3.781Z",
    transform: "translate(-167.095 -234.401)",
    fill: "#ffb6b6"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17635",
    "data-name": "Path 17635",
    d: "M392.341,433.777l-4.973-8.261.1-.063a3.753,3.753,0,0,1,5.151,1.28h0l3.037,5.046Z",
    transform: "translate(-338.982 -346.277)",
    fill: "#2f2e41"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17636",
    "data-name": "Path 17636",
    d: "M591.818,305.753l1.542-2.562-9.149-7.168-2.276,3.781Z",
    transform: "translate(-439.988 -223.816)",
    fill: "#ffb6b6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17637",
    "data-name": "Path 17637",
    d: "M806.407,417.779l3.037-5.046h0a3.753,3.753,0,0,1,5.151-1.28l.1.063-4.973,8.261Z",
    transform: "translate(-655.807 -335.693)",
    fill: "#2f2e41"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17638",
    "data-name": "Path 17638",
    d: "M274.385,195.734l-.582,2.326-15.716,12.581-16.914,15.806,1.814,4.218L283.3,203.684l45.451,23.56,2.031-4.65-20.741-13.9L292.89,196.862Z",
    transform: "translate(-182.345 -147.99)",
    fill: "#2f2e41"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17639",
    "data-name": "Path 17639",
    d: "M566.971,196.236l-6.793,2.229.918,24.744s11.814,7.093,19.087-.958V197.5l-4.056-1.265Z",
    transform: "translate(-469.639 -173.378)",
    fill: "#7d8df7"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17640",
    "data-name": "Path 17640",
    d: "M628.876,203.123l1.508-1.7a6.1,6.1,0,0,1,3.842,6.126c-.35,4.6-2.813,19.21-2.813,19.21l-.464,9.533h-4.376l1.744-24.654Z",
    transform: "translate(-519.839 -177.299)",
    fill: "#7d8df7"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17641",
    "data-name": "Path 17641",
    d: "M551.366,206.123l-1.508-1.7a6.1,6.1,0,0,0-3.842,6.126c.349,4.6,2.813,19.21,2.813,19.21l.463,9.533h4.376l-1.744-24.654Z",
    transform: "translate(-458.916 -179.567)",
    fill: "#7d8df7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_945",
    "data-name": "Ellipse 945",
    cx: 2.683,
    cy: 2.683,
    r: 2.683,
    transform: "translate(89.913 58.284)",
    fill: "#ffb6b6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_946",
    "data-name": "Ellipse 946",
    cx: 2.683,
    cy: 2.683,
    r: 2.683,
    transform: "translate(106.255 58.284)",
    fill: "#ffb6b6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_947",
    "data-name": "Ellipse 947",
    cx: 7.431,
    cy: 7.431,
    r: 7.431,
    transform: "translate(93.101 5.964)",
    fill: "#2f2e41"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_948",
    "data-name": "Ellipse 948",
    cx: 5.991,
    cy: 5.991,
    r: 5.991,
    transform: "translate(94.765 9.089)",
    fill: "#ffb6b6"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17642",
    "data-name": "Path 17642",
    d: "M576.256,138.958a8.148,8.148,0,0,0,4.657,1.439,4.993,4.993,0,0,1-1.979.814,16.43,16.43,0,0,0,6.711.038,4.343,4.343,0,0,0,1.4-.483,1.778,1.778,0,0,0,.867-1.16,2.4,2.4,0,0,0-1.189-2.12,8.773,8.773,0,0,0-7.372-1.473,4.036,4.036,0,0,0-2.183,1.234,1.989,1.989,0,0,0-.184,2.362Z",
    transform: "translate(-481.795 -127.646)",
    fill: "#2f2e41"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17643",
    "data-name": "Path 17643",
    d: "M389.261,795.96H189.244a.244.244,0,1,1,0-.488H389.261a.244.244,0,1,1,0,.488Z",
    transform: "translate(-189 -626.447)",
    fill: "#3f3d56",
    opacity: 0
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17644",
    "data-name": "Path 17644",
    d: "M583.61,610.472a6.83,6.83,0,0,0,13.66,0Z",
    transform: "translate(-487.355 -486.573)",
    fill: "#3f3d56"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_949",
    "data-name": "Ellipse 949",
    cx: 5.854,
    cy: 5.854,
    r: 5.854,
    transform: "translate(122.384 103.654)",
    fill: "#f0f0f0"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_950",
    "data-name": "Ellipse 950",
    cx: 5.854,
    cy: 5.854,
    r: 5.854,
    transform: "translate(71.892 103.654)",
    fill: "#f0f0f0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMydashboard);
export default __webpack_public_path__ + "static/media/mydashboard.207fcd573206a1e478cac219afc04334.svg";
export { ForwardRef as ReactComponent };